export const crmCustomersData = [
  {
    id: 1,
    name: '이가람',
    nickname: '람쥐썬더3565',
    avatar: '/static/avatar-photo/avatar-1.png',
    posts: 0,
    comments: 0,
    permission: '개인',
    partnership: '미가입',
    accountActive: '활성',
    customerType: '일반',
    email: 'fkawnlTjsej@gmail.com',
    phone: '+82 10-2323-3233',
    company: '한솔농산',
    sales: '5,000',
    niceScore: 500,
    employees: 24,
  },
  {
    id: 2,
    name: '김민수',
    nickname: '민수킹1234',
    avatar: '/static/avatar-photo/avatar-2.png',
    posts: 5,
    comments: 12,
    permission: '개인',
    partnership: '가입',
    accountActive: '활성',
    customerType: 'VIP',
    email: 'minsu.kim@example.com',
    phone: '+82 10-1234-5678',
    company: '테크솔루션',
    sales: '15,000',
    niceScore: 720,
    employees: 45,
  },
  {
    id: 3,
    name: '박지영',
    nickname: '지영파크88',
    avatar: '/static/avatar-photo/avatar-3.png',
    posts: 23,
    comments: 45,
    permission: '기업',
    partnership: '가입',
    accountActive: '활성',
    customerType: '기업',
    email: 'jiyoung.park@business.com',
    phone: '+82 10-9876-5432',
    company: '글로벌무역',
    sales: '120,000',
    niceScore: 850,
    employees: 120,
  },
  {
    id: 4,
    name: '최준호',
    nickname: 'junho_choi',
    avatar: '/static/avatar-photo/avatar-4.png',
    posts: 8,
    comments: 20,
    permission: '개인',
    partnership: '미가입',
    accountActive: '비활성',
    customerType: '일반',
    email: 'junho.choi@email.com',
    phone: '+82 10-5555-7777',
    company: '스타트업코리아',
    sales: '8,500',
    niceScore: 650,
    employees: 12,
  },
  {
    id: 5,
    name: '정수연',
    nickname: 'suyeon_j',
    avatar: '/static/avatar-photo/avatar-1.png',
    posts: 15,
    comments: 30,
    permission: '개인',
    partnership: '가입',
    accountActive: '활성',
    customerType: 'VIP',
    email: 'suyeon.jung@company.kr',
    phone: '+82 10-3333-4444',
    company: '디자인스튜디오',
    sales: '22,000',
    niceScore: 780,
    employees: 18,
  },
  {
    id: 6,
    name: '강태영',
    nickname: '태영강777',
    avatar: '/static/avatar-photo/avatar-2.png',
    posts: 3,
    comments: 8,
    permission: '기업',
    partnership: '가입',
    accountActive: '활성',
    customerType: '기업',
    email: 'taeyoung.kang@biz.com',
    phone: '+82 10-7777-8888',
    company: '건설엔지니어링',
    sales: '250,000',
    niceScore: 920,
    employees: 200,
  },
  {
    id: 7,
    name: '윤서진',
    nickname: 'seojin_y',
    avatar: '/static/avatar-photo/avatar-3.png',
    posts: 12,
    comments: 25,
    permission: '개인',
    partnership: '미가입',
    accountActive: '비활성',
    customerType: '일반',
    email: 'seojin.yoon@mail.com',
    phone: '+82 10-2222-3333',
    company: '마케팅에이전시',
    sales: '18,500',
    niceScore: 690,
    employees: 30,
  },
  {
    id: 8,
    name: '임채원',
    nickname: 'chaewon_lim',
    avatar: '/static/avatar-photo/avatar-4.png',
    posts: 7,
    comments: 15,
    permission: '개인',
    partnership: '가입',
    accountActive: '활성',
    customerType: 'VIP',
    email: 'chaewon.lim@example.kr',
    phone: '+82 10-6666-9999',
    company: '푸드앤컴퍼니',
    sales: '32,000',
    niceScore: 740,
    employees: 55,
  },
  {
    id: 9,
    name: '송민재',
    nickname: 'minjae_song',
    avatar: '/static/avatar-photo/avatar-1.png',
    posts: 18,
    comments: 38,
    permission: '기업',
    partnership: '가입',
    accountActive: '활성',
    customerType: '기업',
    email: 'minjae.song@corp.com',
    phone: '+82 10-4444-5555',
    company: 'IT솔루션즈',
    sales: '95,000',
    niceScore: 810,
    employees: 85,
  },
  {
    id: 10,
    name: '한지우',
    nickname: 'jiwoo_han',
    avatar: '/static/avatar-photo/avatar-2.png',
    posts: 4,
    comments: 10,
    permission: '개인',
    partnership: '미가입',
    accountActive: '비활성',
    customerType: '일반',
    email: 'jiwoo.han@email.kr',
    phone: '+82 10-8888-7777',
    company: '패션코리아',
    sales: '12,500',
    niceScore: 660,
    employees: 22,
  },
];
